import { AbstractDataProvider, IDataProvider, IPartialItem, IItem, IList } from 'components/system/data-provider';
import { A9Service } from 'components/system/angular';

// test data start

const firstSubscription: ISubscription = {
    id: 1,
    startDate: '2017-03-01',
    endDate: '2018-02-28',
    subscriptionAmount: 2400.0,
    invoiceAmount: null,
    invoiceDate: null,
    voidAmount: null,
    voidDate: null
};
const secondSubscription: ISubscription = {
    id: 2,
    startDate: '2016-03-01',
    endDate: '2017-02-28',
    subscriptionAmount: 2200.0,
    invoiceAmount: 2200.0,
    invoiceDate: '2016-08-27',
    voidAmount: null,
    voidDate: null
};

const testSubscriptions = [firstSubscription, secondSubscription];

type ISubscriptionList = IList<ISubscription>;

interface ISubscription extends IItem {
    startDate: string;
    endDate: string;
    subscriptionAmount: number;
    invoiceAmount: number;
    invoiceDate: string;
    voidAmount: number;
    voidDate: string;
}

// test data end

@A9Service('customerSubscriptionsService')
export class CustomerSubscriptionsService {
    private dataProvider: IDataProvider<ISubscription> = null;

    constructor(protected $http: angular.IHttpService) {
        this.dataProvider = new CustomerSubscriptionsDataProvider();
    }

    list(collectionParams, resourceParams, cancel: Promise<void> = null): Promise<ISubscriptionList> {
        return this.dataProvider.list(collectionParams, resourceParams, cancel);
    }

    get(resourceParams?: object): Promise<ISubscription> {
        return this.dataProvider.get(resourceParams);
    }

    update(item, resourceParams?: object): Promise<ISubscription> {
        return this.dataProvider.update(item, resourceParams);
    }

    patch(partialItem: IPartialItem, resourceParams?: object): Promise<ISubscription> {
        return this.dataProvider.patch(partialItem, resourceParams);
    }

    add(item, resourceParams?: object): Promise<ISubscription> {
        return this.dataProvider.add(item, resourceParams);
    }

    remove(resourceParams): Promise<any> {
        return this.dataProvider.remove(resourceParams);
    }
}

export class CustomerSubscriptionsDataProvider extends AbstractDataProvider<ISubscription> {
    constructor() {
        super();
    }

    list(_collectionParams, _resourceParams, _cancel: Promise<any>): Promise<ISubscriptionList> {
        return new Promise(resolve => {
            resolve({
                items: testSubscriptions,
                page: null
            });
        });
    }

    get(_resourceParams?: object): Promise<ISubscription> {
        return new Promise(resolve => {
            resolve(firstSubscription);
        });
    }

    update(_item, _resourceParams?: object): Promise<ISubscription> {
        return new Promise(resolve => {
            resolve(firstSubscription);
        });
    }

    patch(_partialItem: IPartialItem, _resourceParams?: object): Promise<ISubscription> {
        return new Promise(resolve => {
            resolve(firstSubscription);
        });
    }

    add(_item, _resourceParams?: object): Promise<ISubscription> {
        return new Promise(resolve => {
            resolve(firstSubscription);
        });
    }

    remove(_resourceParams?: object): Promise<any> {
        return new Promise<void>(resolve => {
            resolve();
        });
    }
}
